import { render, staticRenderFns } from "./SectionInfoYarmarka.vue?vue&type=template&id=5cd0ea10"
import script from "./SectionInfoYarmarka.vue?vue&type=script&lang=ts"
export * from "./SectionInfoYarmarka.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports